import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=46c06543&scoped=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&lang=js"
import style0 from "./StackedBarChart.vue?vue&type=style&index=0&id=46c06543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c06543",
  null
  
)

export default component.exports